<template>
  <v-layout xs12 pa-1 row wrap>
    <v-flex shrink>
      <v-chip-group :show-arrows="true" >
          <v-chip
            v-for="dtm in dayTripModifiers"
            :key="dtm.day_of_week"
            @click:close="close(dtm)"
            @click="edit(dtm)"
            close
            >{{ dtm.day_of_week }}</v-chip
          >
        </v-chip-group>
    </v-flex>
    <v-flex pt-2>
      <v-btn @click="emitAdd" x-small>Add Day Trip Modifier</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "day_trip_modifiers",
  components: {
  },
  props: {
    dayTripModifiers: Array,
  },
  data() {
    return {
      menu: false,
      skipWeekends: false,
      same: false,
    };
  },
  computed: {

  },
  methods: {
    close(dtm) {
      this.$emit("remove", dtm);
    },
    edit(dtm) {
      this.$emit("edit", dtm);
    },
   emitAdd() {
     this.$emit("addDayTrip");
   }
   
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
